<template>
    <div class="container">
        <div>
            <div class="beaming-icon-container">
                <div class="beaming-icon">
                    <div class="pulse"></div>
                    <div class="pulse"></div>
                    <div class="pulse"></div>
                    <img :src="loadFile(images.failure)">
                </div>
            </div>
        </div>
        <div>
            <div class="messageTitle">
                {{ $t('Not Supported Message Title') }}
            </div>
            <div class="messageContent">
                {{ $t('Not Supported Message Content') }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { loadFile } from '@/components/utils.js'

const images = {
    failure: 'alert-circle.svg',
}

</script>

<style scoped lang="scss">
@import './styles/notSupported.scss';
</style>
